$(document).ready ->
  IMAGE_PAGE_FILE_LIMITS = $('#image_page_file_limits').val() && JSON.parse($('#image_page_file_limits').val())

  file_preview = $(".upload-preview-ipad img")
  spots_file_preview = ''
  cropbox = $('#image_page_image_cropbox')
  cropper_preview = $('#image_page_image_previewbox')
  file_preview_iphone = $(".upload-preview-iphone img")
  cropbox_iphone = $('#image_page_iphone_image_cropbox')
  cropper_preview_iphone = $('#image_page_iphone_image_previewbox')
  fileObject = {}
  fileObjectIphone = {}
  croppie_ipad = ''
  croppie_iphone = ''
  images = {}
  iphone_images = {}

  $(".file").click (event) ->
    $(event.target).val("")
 
   $(".file").on 'drop', (event) ->
    $(event.target).val("")
 
  $(".iphone-file").click (event) ->
    $(event.target).val("")
 
   $(".iphone-file").on 'drop', (event) ->
    $(event.target).val("")
  
  $('.back-image-page').click (event) ->
    modal = $(event.target).attr("href")
    $('.darkroom-image-container').remove()
    $(modal).closeModal()
    return
  
  $(".image-page-file").change (event) ->
    $(this).siblings("#openEditImageModal").css("display", "inline-block")
    $(this).siblings(".edit-alt-text-image-page-modal").css("display", "inline-block")
    $("#openEditInfoSpots").css("display", "inline-block")

    file_preview = $(event.target).parents('.image-container').find(".upload-preview-ipad").find("img")
    spots_file_preview = $('#editInfoSpotsModal').find(".upload-preview-ipad").find("img")

    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    fileObject.filetype = file.type;
    fileObject.filename = file.name;
    language = $('#page_language_selection').val();
    images[language] = {name: file.name, type: file.type}
    
    return if fileSizeNotInLimit(file,event,"#openEditImageModal",IMAGE_PAGE_FILE_LIMITS["image"])

    reader = new FileReader()
    reader.onload = (e) ->
      image_base64 = e.target.result
      file_preview.attr "src", image_base64
      spots_file_preview.attr "src", image_base64

      cropbox.attr "src", image_base64      
      cropper_preview.attr "src", image_base64
      return
    reader.readAsDataURL file
    return
    
  $(".image-page-iphone-file").change (event) ->
    $(this).siblings("#openEditIphoneImageModal").css("display", "inline-block")
    $(this).siblings(".edit-alt-text-image-page-iphone-modal").css("display", "inline-block")

    file_preview_iphone = $(event.target).parents('.image-container').find(".upload-preview-iphone").find("img")

    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    fileObjectIphone.filetype = file.type;
    fileObjectIphone.filename = file.name;
    language = $('#page_language_selection').val();
    iphone_images[language] = {name: file.name, type: file.type}
    
    return if fileSizeNotInLimit(file,event,"#openEditIphoneImageModal",IMAGE_PAGE_FILE_LIMITS["iphone_image"])

    reader = new FileReader()
    reader.onload = (e) ->
      image_base64 = e.target.result
      file_preview_iphone.attr "src", image_base64
      
      cropbox_iphone.attr "src", image_base64      
      cropper_preview_iphone.attr "src", image_base64
      return
    reader.readAsDataURL file
    return
    
  $('.open-edit-image-modal').click (event) ->
    $("#image_modal").openModal();
    $("#image_modal").html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>');

    if window.info_spots && window.info_spots.length > 0
      alert "Cropping the image will remove all added 'info spots'"
      window.info_spots = []
      window.info_spots_multi = []

    details = $(this).data('file-details').split(',')
    if !fileObject.filetype && details.length > 1
      fileObject.filetype = details[1].slice(1)
      fileObject.filename = details[0]
      language = $('#page_language_selection').val();
      images[language] = {name: details[0], type: details[1].slice(1)}

  $('.open-edit-iphone-image-modal').click (event) ->
    $("#iphone_image_modal").openModal();
    $("#iphone_image_modal").html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>');

    if window.info_spots && window.info_spots.length > 0
      alert "Cropping the image will remove all added 'info spots'"
      window.info_spots = []
      window.info_spots_multi = []
    $(cropbox).attr "src", $($(event.target)[0]).siblings('.upload-preview-ipad').find("img").attr("src")

    details = $(this).data('file-details').split(',')
    if !fileObject.filetype && details.length > 1
      fileObject.filetype = details[1].slice(1)
      fileObject.filename = details[0]
    
    $(".upload-preview").removeClass "upload-preview"
    $(".upload-preview-ipad").addClass "upload-preview"

    if $('#image_page_image_type').val() == "Text With Image"
      croppie_ipad = $('.croppie-ipad').croppie({
        viewport: {
          width: 400,
          height: 300
        }
      });
      if $('#editImageModal').find('.croppie-container').length > 1
        $('#editImageModal').find('.croppie-container:last').appendTo('#editImageModal .main-image-container')
        $('#editImageModal').find('.croppie-container:first').remove()

    else
      croppie_ipad = $('.croppie-ipad').croppie({
        viewport: {
          width: 320,
          height: 180
        }
      });
      if $('#editImageModal').find('.croppie-container').length > 1
        $('#editImageModal').find('.croppie-container:last').appendTo('#editImageModal .main-image-container')
        $('#editImageModal').find('.croppie-container:first').remove()

    return

  $('.save-cropped-image-btn').click ->
    if $('#editImageModal:visible').length > 0
      src = croppie_ipad.get(0).src
      format = croppie_ipad.get(0).src.split(';')[0].split('/')[1]
      if !format
        format = 'jpeg'
      croppie_ipad.croppie('result',
        type: 'canvas'
        size: 'original'
        format: format
        quality: '0.99'
      ).then (response) ->
        $('.upload-preview-ipad img').attr('src', response)
    else if $('#editIphoneImageModal:visible').length > 0
      src = croppie_iphone.get(0).src
      format = croppie_iphone.get(0).src.split(';')[0].split('/')[1]
      if !format
        format = 'jpeg'
      croppie_iphone.croppie('result',
        type: 'canvas'
        size: 'original'
        format: format
        quality: '0.99'
      ).then (response) ->
        $('.upload-preview-iphone img').attr('src', response)

  $('#openEditIphoneImageModal').click (event) ->
    $('.darkroom-image-container').remove();

    $(cropbox_iphone).attr "src", $($(event.target)[0]).siblings('.upload-preview-iphone').find("img").attr("src")

    details = $(this).data('file-details').split(',')
    if !fileObjectIphone.filetype && details.length > 1
      fileObjectIphone.filetype = details[1].slice(1)
      fileObjectIphone.filename = details[0]
      language = $('#page_language_selection').val();
      iphone_images[language] = {name: details[0], type: details[1].slice(1)}

  $('#new_image_page').submit (e) ->
    $('#loading-modal').openModal({dismissible: false})
    disablePageSubmit();
    e.preventDefault()
    image_path = ''
    image_path_iphone = ''
    draft_image = ""
    allow_description = ""
    ignore_js = $('#page_convert_to').val() != ''
    asset_library_allowed = $(e.target).children().find("#asset_library_allowed").val()

    if $('#image_page_draft_image').is(':checked')
      draft_image = 1
    else
      draft_image = 0
      
    if $('#image_page_image_type').val() == "Info Spots"
      allow_description = 0
    else
      allow_description = 1

    index = 0
    $(".media-container.upload-preview-ipad").each ->
      language_id = $($(".media-container.upload-preview-ipad")[index]).data('language-id').toString()
      images[language_id] = {} if images[language_id] == undefined
      unless $($(".media-container.upload-preview-ipad")[index]).find('img').attr('src') == undefined
        images[language_id]['content'] = $($(".upload-preview-ipad")[index]).find("img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")
      index++

    index = 0
    $(".media-container.upload-preview-iphone").each ->
      language_id = $($(".media-container.upload-preview-iphone")[index]).data('language-id').toString()
      iphone_images[language_id] = {} if iphone_images[language_id] == undefined
      unless $($(".media-container.upload-preview-iphone")[index]).find('img').attr('src') == undefined
        iphone_images[language_id]['content'] = $($(".upload-preview-iphone")[index]).find("img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")
      index++

    if $('#image_page_left_align').is(':checked')
      left_align = 0;
    else
      left_align = 1;

    unless $(".upload-preview-ipad img").attr('src') == undefined
      image_path = $(".upload-preview-ipad img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")

    unless $(".upload-preview-iphone img").attr('src') == undefined
      image_path_iphone = $(".upload-preview-iphone img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")
      
    description_multi = {}
    for answer in $('textarea[id^="image_page_description_multi"], textarea[id^="image_page_page_attributes_description_multi"]')
      id = $(answer).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      val = CKEDITOR.instances[id].getData();
      description_multi[key] = val
      
    name_multi = {}
    for answer in $('input[id^="image_page_name_multi"], input[id^="image_page_page_attributes_name_multi"]')
      id = $(answer).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      val = $(answer).val()
      name_multi[key] = val

    alt_text_for_pages_image = {}
    for alt_text in $('input[id^="image_page_alt_text"]')
      id = $(alt_text).attr("id")
      key = id.split("_").pop()
      val = $(alt_text).val()
      alt_text_for_pages_image[key] = val

    alt_text_for_pages_iphone_image = {}
    for alt_text in $('input[id^="image_page_iphone_alt_text"]')
      id = $(alt_text).attr("id")
      key = id.split("_").pop()
      val = $(alt_text).val()
      alt_text_for_pages_iphone_image[key] = val
      
    info_multi = {}
    for answer in $('textarea[id^="image_page_page_attributes_info_multi"]')
      id = $(answer).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      val = CKEDITOR.instances[id].getData();
      info_multi[key] = val

    asset_id_for_images = {}
    for asset_id in $('input[id^="asset-id-page-image"]')
      id = $(asset_id).attr("id")
      key = id.split("-").pop()
      val = $(asset_id).val()
      asset_id_for_images[key] = val

    asset_id_for_images_iphone = {}
    for asset_id in $('input[id^="asset-id-iphone-page-image"]')
      id = $(asset_id).attr("id")
      key = id.split("-").pop()
      val = $(asset_id).val()
      asset_id_for_images_iphone[key] = val

    if asset_library_allowed == true || asset_library_allowed == 'true'
      images = ''
      iphone_images = ''

    $.ajax(
      type: 'POST',
      url: "#{$(this).attr('action')}.json"
      enctype: 'multipart/form-data',      
      data:
        'page[convert_to]': $('#page_convert_to').val()
        'page_to_convert': $('#page_to_convert').val()
        'image_page[alt_text_for_pages_image]': alt_text_for_pages_image
        'image_page[alt_text_for_pages_iphone_image]': alt_text_for_pages_iphone_image
        'image_page[custom_images]': images
        'image_page[custom_iphone_images]': iphone_images
        'image_page[page_attributes][name_multi]': name_multi
        'image_page[page_attributes][description_multi]': description_multi
        'image_page[asset_id_for_images]': asset_id_for_images
        'image_page[asset_id_for_images_iphone]': asset_id_for_images_iphone
        'image_page[page_attributes][chapter_id]': $('#image_page_page_attributes_chapter_id').val()        
        'image_page[page_attributes][sequence]': $('#image_page_page_attributes_sequence').val()
        'image_page[page_attributes][score]': $('#image_page_page_attributes_score').find(':selected').val()
        'image_page[page_attributes][info_multi]': info_multi
        'image_page[page_attributes][status]': $('#image_page_page_attributes_status').find(':selected').val()
        'image_page[image_type]': $('#image_page_image_type').val()
        'image_page[spots]': window.info_spots
        'image_page[spots_multi]': window.info_spots_multi
        'image_page[draft_image]': draft_image
        'image_page[allow_description]': allow_description
        'image_page[left_align]': left_align
        'authenticity_token': $('input[name=authenticity_token]').val()
    ).done((data, textStatus, jqXHR) ->
      if(!ignore_js)
        window.safeRedirect(data["redirect_to"])
      else
        window.safeRedirect(data["convert_to"])
      return
    ).fail((jqXHR, textStatus, errorThrown) ->
      alert(jqXHR.responseText)
      $("input[type='submit']").val('Create')
      $("input[type='submit']").attr('disabled', false)
      $('#loading-modal').closeModal()
      return
    )
    false
    
  $('form[id^="edit_image_page_"]').submit (e) ->
    $('#loading-modal').openModal({dismissible: false})
    disablePageSubmit();
    e.preventDefault()
    image_path = ''
    image_path_iphone = ''
    draft_image = ""
    allow_description = ""
    ignore_js = $('#page_convert_to').val() != ''
    asset_library_allowed = $(e.target).children().find("#asset_library_allowed").val()

    if $('#image_page_draft_image').is(':checked')
      draft_image = 1
    else
      draft_image = 0

    if $('#image_page_image_type').val() == "Info Spots"
      allow_description = 0
    else
      allow_description = 1

    index = 0
    $(".media-container.upload-preview-ipad").each ->
      language_id = $($(".media-container.upload-preview-ipad")[index]).data('language-id').toString()
      images[language_id] = {} if images[language_id] == undefined
      if $($(".media-container.upload-preview-ipad")[index]).find('img').attr('src') != undefined && $($(".media-container.upload-preview-ipad")[index]).find('img').attr('src').indexOf("base64") != -1
        images[language_id]['content'] = $($(".upload-preview-ipad")[index]).find("img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")
      index++

    index = 0
    $(".media-container.upload-preview-iphone").each ->
      language_id = $($(".media-container.upload-preview-iphone")[index]).data('language-id').toString()
      iphone_images[language_id] = {} if iphone_images[language_id] == undefined
      if $($(".media-container.upload-preview-iphone")[index]).find('img').attr('src') != undefined && $($(".media-container.upload-preview-iphone")[index]).find('img').attr('src').indexOf("base64") != -1
        iphone_images[language_id]['content'] = $($(".upload-preview-iphone")[index]).find("img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")
      index++

    if $('#image_page_left_align').is(':checked')
      left_align = 0;
    else
      left_align = 1;

    if $(".upload-preview-ipad img").attr('src') != undefined && $(".upload-preview-ipad img").attr('src').indexOf("base64") != -1
      image_path = $(".upload-preview-ipad img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")
    if $(".upload-preview-iphone img").attr('src') != undefined && $(".upload-preview-iphone img").attr('src').indexOf("base64") != -1
      image_path_iphone = $(".upload-preview-iphone img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")

    description_multi = {}
    for answer in $('textarea[id^="image_page_description_multi"], textarea[id^="image_page_page_attributes_description_multi"]')
      id = $(answer).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      val = CKEDITOR.instances[id].getData();
      description_multi[key] = val
      
    name_multi = {}
    for answer in $('input[id^="image_page_name_multi"], input[id^="image_page_page_attributes_name_multi"]')
      id = $(answer).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      val = $(answer).val()
      name_multi[key] = val
      
    info_multi = {}
    for answer in $('textarea[id^="image_page_page_attributes_info_multi"]')
      id = $(answer).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      val = CKEDITOR.instances[id].getData();
      info_multi[key] = val

    alt_text_for_pages_image = {}
    for alt_text in $('input[id^="image_page_alt_text"]')
      id = $(alt_text).attr("id")
      key = id.split("_").pop()
      val = $(alt_text).val()
      alt_text_for_pages_image[key] = val

    alt_text_for_pages_iphone_image = {}
    for alt_text in $('input[id^="image_page_iphone_alt_text"]')
      id = $(alt_text).attr("id")
      key = id.split("_").pop()
      val = $(alt_text).val()
      alt_text_for_pages_iphone_image[key] = val

    asset_id_for_images = {}
    for asset_id in $('input[id^="asset-id-page-image"]')
      id = $(asset_id).attr("id")
      key = id.split("-").pop()
      val = $(asset_id).val()
      asset_id_for_images[key] = val

    asset_id_for_images_iphone = {}
    for asset_id in $('input[id^="asset-id-iphone-page-image"]')
      id = $(asset_id).attr("id")
      key = id.split("-").pop()
      val = $(asset_id).val()
      asset_id_for_images_iphone[key] = val

    if asset_library_allowed == true || asset_library_allowed == 'true'
      images = ''
      iphone_images = ''
    $.ajax(
      type: 'POST',
      url: "#{$(this).attr('action')}.json"
      enctype: 'multipart/form-data',      
      data:
        'page[convert_to]': $('#page_convert_to').val()
        'page_to_convert': $('#page_to_convert').val()
        'image_page[alt_text_for_pages_image]': alt_text_for_pages_image
        'image_page[alt_text_for_pages_iphone_image]': alt_text_for_pages_iphone_image
        'image_page[custom_images]': images
        'image_page[custom_iphone_images]': iphone_images
        'image_page[asset_id_for_images]': asset_id_for_images
        'image_page[asset_id_for_images_iphone]': asset_id_for_images_iphone
        'image_page[page_attributes][name_multi]': name_multi
        'image_page[page_attributes][description_multi]': description_multi
        'image_page[page_attributes][chapter_id]': $('#image_page_page_attributes_chapter_id').val()
        'image_page[page_attributes][score]': $('#image_page_page_attributes_score').find(':selected').val()
        'image_page[page_attributes][id]': $('#image_page_page_attributes_id').val()
        'image_page[page_attributes][info_multi]': info_multi
        'image_page[page_attributes][status]': $('#image_page_page_attributes_status').find(':selected').val()
        'image_page[image_type]': $('#image_page_image_type').val()
        'image_page[spots]': window.info_spots
        'image_page[spots_multi]': window.info_spots_multi
        'image_page[draft_image]': draft_image
        'image_page[allow_description]': allow_description
        'image_page[left_align]': left_align
        'authenticity_token': $('input[name=authenticity_token]').val()
        '_method': 'patch'
    ).done((data, textStatus, jqXHR) ->
      if(!ignore_js)
        window.safeRedirect(data["redirect_to"])
      else
        window.safeRedirect(data["convert_to"])
      return
    ).fail((jqXHR, textStatus, errorThrown) ->
      alert(jqXHR.responseText)
      $("input[type='submit']").val('Update')
      $("input[type='submit']").attr('disabled', false)
      $('#loading-modal').closeModal()
      return
    )
    false

  return
